export default __webpack_public_path__ + "static/media/thumbnail.f23f27c4.png";